export default "__VITE_ASSET__BAiXIW7C__"